module.exports = __webpack_public_path__ + "img/uploadimg.9a9bcfb3.png";